// Import statements at the top of the file

import { useSelector } from 'react-redux';
import { Post } from '../AxiosFunctions';
import { apiHeader, BaseURL } from '../Config';
// Custom hook
const useApi = () => {
  const token = useSelector((state) => state?.authReducer?.accessToken);
  const updateEmailToken = useSelector((state) => state?.commonReducer?.updateEmailToken);
  const verifyEmailUpdateToken = useSelector((state) => state?.commonReducer?.verifyToken);
  const userData = useSelector((state) => state?.authReducer);
  const doctorClinicId = userData?.clinicData?.[0]?.doctorClinicId ?? 0;
  const generateOtpForSignup = async (params) => {
    const response = await Post(
      BaseURL('auth/generate-otp-signup'),
    params,
      apiHeader()
    );
    return response;
  };
  const verifyOtpForSignUp = async (params) => {
    const response = await Post(BaseURL('auth/verify-otp'), params, apiHeader(token));
    return response;
  };
  //this api also use for set password or pin code in first time
  const forgotPassword = async (params) => {
    console.log("token..",token)
    const response = await Post(BaseURL('auth/forgot-password'), params, apiHeader(token));
    return response;
  };
  /**
   *
   * @param {string} params
   * @returns {Promise}
   */
  const getCities = async (params) => {
    const response = await Post(
      BaseURL(`auth/get-cities?StateName=${params}`),
      {},
      apiHeader(token)
    );

    return response;
  };

  const registerDoctor = async (params) => {
    const response = await Post(BaseURL(`auth/register-doctor`), params, apiHeader(token));
    return response;
  };
  const registerPA = async (params) => {
    const response = await Post(BaseURL(`auth/register-pa`), params, apiHeader(token));
    return response;
  };
  const sigin = async (params) => {
    const response = await Post(BaseURL(`auth/login`), params);
    return response;
  };
  //provide listing of patients in table
  const getAllPatientsListing = async (params) => {
    const response = await Post(BaseURL(`patient/get-patients`), params, apiHeader(token));
    return response;
  };
  //provide exist patients list
  const getAllPatients = async (params) => {
    const response = await Post(BaseURL(`patient/get-all-patients`), params, apiHeader(token));
    return response;
  };
  const getPatientDetails = async () => {
    const response = await Post(
      BaseURL(''),
      {
        doctorClinicId: 0,
        patientId: 0,
        doctorPatientId: 0,
        patientName: 'string',
        gender: 'string',
        age: 0
      },
      apiHeader(token)
    );
    return response;
  };

  const linkOrAddPatient = async (params) => {
    let url = 'patient/register-and-add-patient';
    if (params?.patientId) {
      url = 'clinic/add-patient-queue';
    }
    const response = await Post(BaseURL(url), params, apiHeader(token));
    return response;
  };

  const editPatientDetail = async (params) => {
    const response = await Post(
      BaseURL('patient/edit-patient-details'),
      { doctorClinicId, ...params },
      apiHeader(token)
    );
    return response;
  };
  const getAllClinicPatientsQueue = async (params) => {
    const response = await Post(BaseURL('clinic/get-patient-queue'), params, apiHeader(token));
    return response;
  };

  const deletePatientfromQueue = async (params) => {
    const response = await Post(
      BaseURL('clinic/delete-from-patient-queue'),
      params,
      apiHeader(token)
    );
    return response;
  };

  //send patien by queue
  const doctorSendNextPatient = async (params) => {
    const response = await Post(
      BaseURL('doctor/request-send-next-patient'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );
    return response;
  };
  //send patien

  const requestNextPatient = async (params) => {
    const response = await Post(
      BaseURL('doctor/request-next-patient'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );
    return response;
  };
  //history
  const getAllClinicPatientsChecked = async (params) => {
    const response = await Post(BaseURL('get-patient-queue-checked'), params, apiHeader(token));
  };

  //Doctors Api start
  const getServices = async () => {
    const response = await Post(
      BaseURL('doctor/get-additional-fees'),
      { doctorClinicId },
      apiHeader(token)
    );
    return response;
  };

  const addOrEditService = async (params) => {
    let url = 'add-additional-fees';
    if (params?.serviceId) {
      url = 'update-additional-fees';
    }
    const response = await Post(
      BaseURL(`doctor/${url}`),
      { doctorClinicId, ...params },
      apiHeader(token)
    );
    return response;
  };

  const getPatientQueueChecked = async (params) => {
    const response = await Post(
      BaseURL('clinic/get-patient-queue-checked'),
      { doctorClinicId },
      apiHeader(token)
    );

    return response;
  };

  const getPatientPaymentHistory = async (params) => {
    const response = await Post(
      BaseURL('patient/get-patient-payment-history'),
      { doctorClinicId, ...params },
      apiHeader(token)
    );

    return response;
  };
  const deleteService = async (params) => {
    const response = await Post(BaseURL(`doctor/delete-additional-fees`), params, apiHeader(token));
    return response;
  };

  //Coctors Api End

  const startSession = async (params = null) => {
    const response = await Post(
      BaseURL('clinic/start-session'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );
    return response;
  };

  const sessionEnd = async (params = null) => {
    const response = await Post(
      BaseURL('clinic/end-session'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );
    return response;
  };

  const editPatientQueuFees = async (params) => {
    const response = await Post(
      BaseURL('clinic/edit-patient-queue-fees'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );

    return response;
  };
  const getSession = async (params = null) => {
    const response = await Post(
      BaseURL('clinic/get-session'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );
    return response;
  };

  const addDrugAllergies = async (params = null) => {
    const response = await Post(
      BaseURL('doctor/add-drug-allergy'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );
    return response;
  };
  const addPreviousService = async (params = null) => {
    const response = await Post(
      BaseURL('doctor/add-previous-service'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );
    return response;
  };

  const longtermConditions = async (params = null) => {
    const response = await Post(
      BaseURL('doctor/add-long-term-condition'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );
    return response;
  };
  const addDisability = async (params = null) => {
    const response = await Post(
      BaseURL('doctor/add-disability'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );
    return response;
  };
  const addPreviousMedication = async (params = null) => {
    const response = await Post(
      BaseURL('doctor/add-previous-medication'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );
    return response;
  };

  const addSymptoms = async (params = null) => {
    const response = await Post(
      BaseURL('doctor/add-symptom'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );
    return response;
  };
  const addVitals = async (params = null) => {
    const response = await Post(
      BaseURL('doctor/add-Vitals'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );
    return response;
  };

  const addDiagnosis = async (params = null) => {
    const response = await Post(
      BaseURL('doctor/add-diagnosis'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );
    return response;
  };

  const addDoctorNotes = async (params = null) => {
    const response = await Post(
      BaseURL('doctor/add-doctor-note'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );
    return response;
  };

  const addPrescription = async (params = null) => {
    const response = await Post(
      BaseURL('doctor/add-prescription'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );
    return response;
  };

  const getAllMedicines = async () => {
    const response = await Post(
      BaseURL('doctor/get-medicine'),
      {
        pageNumber: 1,
        pageSize: 250000,
        totalRowsCount: 0,
        sortField: '',
        sortDirection: '',
        search: '',
        filter: {
          doctorClinicId
        }
      },
      apiHeader(token)
    );
    return response;
  };

  const addTest = async (params) => {
    const response = await Post(
      BaseURL('doctor/add-test'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );
    return response;
  };

  const getTest = async () => {
    const response = await Post(BaseURL('doctor/get-test'), {}, apiHeader(token));
    return response;
  };

  const editRequestPatient = async (params) => {
    const response = await Post(
      BaseURL('doctor/edit-request-patient'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );
    return response;
  };

  const getOpdDetails = async (params = null) => {
    const response = await Post(
      BaseURL('clinic/get-opd-detail'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );
    return response;
  };

  const getPatientMedicalInformation = async (params) => {
    const response = await Post(
      BaseURL('clinic/get-patient-medical-information'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );
    return response;
  };

  /* ======  Appointments Start ======= */
  const getAllAppointments = async (params) => {
    const response = await Post(
      BaseURL('appointment/get-appointments'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );
    return response;
  };

  const addAppointment = async (params) => {
    const response = await Post(
      BaseURL('appointment/add-appointment'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );
    return response;
  };

  const addDoctorTime = async (params) => {
    const response = await Post(
      BaseURL('profile/add-doctor-times'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );
    return response;
  };

  const editAppointment = async (params) => {
    const response = await Post(
      BaseURL('appointment/edit-appointment'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );
    return response;
  };

  const moveToQueue = async (params) => {
    const response = await Post(
      BaseURL('appointment/move-to-queue'),
      {
        ...params,
        doctorClinicId
      },
      apiHeader(token)
    );
    return response;
  };
  const getDoctorTimes = async () => {
    const response = await Post(
      BaseURL('profile/get-doctor-times'),
      {
        doctorClinicId
      },
      apiHeader(token)
    );
    return response;
  };

  const getAppointmentSlots = async (params) => {
    const response = await Post(
      BaseURL('appointment/get-appointment-slots'),
      {
        ...params,
        doctorClinicId
      },
      apiHeader(token)
    );
    return response;
  };

  const patientDuration = async (params) => {
    const response = await Post(
      BaseURL('profile/update-appointments'),
      {
        ...params,
        doctorClinicId
      },
      apiHeader(token)
    );
    return response;
  };

  const cancelAppointment = async (params) => {
    const response = await Post(
      BaseURL('appointment/delete-appointment'),
      {
        ...params,
        doctorClinicId
      },
      apiHeader(token)
    );

    return response;
  };
  /* === Appointments End =======  */
  /*

  =======================
  SMS
  ========================
  */

  const getAllSMSPackages = async (params) => {
    const response = await Post(
      BaseURL('doctor/get-sms-packages'),
      {
        ...params,
        doctorClinicId
      },
      apiHeader(token)
    );

    return response;
  };

  const getSmsSubscription = async (params, filter) => {
    const response = await Post(
      BaseURL('doctor/get-sms-subscriptions'),
      {
        ...params,
        filter: {
          doctorClinicId,
          ...filter
        }
      },
      apiHeader(token)
    );

    return response;
  };

  const addSmsSubscription = async (params) => {
    const response = await Post(
      BaseURL('doctor/add-sms-subscription'),
      {
        ...params
      },
      apiHeader(token)
    );
    return response;
  };

  const deleteSmsSubscription = async (params) => {
    const response = await Post(
      BaseURL('doctor/delete-sms-subscription'),
      {
        ...params
      },
      apiHeader(token)
    );
    return response;
  };

  const getALLPackages = async (params) => {
    const response = await Post(
      BaseURL('doctor/get-packages'),
      {
        ...params
      },
      apiHeader(token)
    );
    return response;
  };

  const addSubscription = async (params) => {
    const response = await Post(
      BaseURL('doctor/add-subscription'),
      {
        ...params
      },
      apiHeader(token)
    );
    return response;
  };
  const deleteSubscription = async (params) => {
    const response = await Post(
      BaseURL('doctor/delete-subscription'),
      {
        ...params
      },
      apiHeader(token)
    );
    return response;
  };

  const addMergeSubscription = async (params) => {
    const response = await Post(
      BaseURL('doctor/add-subscription'),
      {
        ...params
      },
      apiHeader(token)
    );
    return response;
  };

  const getPackageSubscription = async (params, filter) => {
    const response = await Post(
      BaseURL('doctor/get-subscriptions'),

      {
        ...params,
        filter: {
          doctorClinicId,
          ...filter
        }
      },

      apiHeader(token)
    );
    return response;
  };

  const generateOtpUpdateEmail = async (params) => {
    const response = await Post(
      BaseURL('auth/generate-otp-update-email'),
      {
        ...params
      },
      apiHeader(token)
    );
    return response;
  };

  const updateEmail = async (params) => {
    const response = await Post(
      BaseURL('profile/update-Email'),
      {
        ...params
      },
      apiHeader(verifyEmailUpdateToken)
    );
    return response;
  };
  const verifyOtpForUpdateEmail = async (params) => {
    const response = await Post(BaseURL('auth/verify-otp'), params, apiHeader(updateEmailToken));
    return response;
  };

  const updateSecondaryNumber = async (params) => {
    const response = await Post(BaseURL('profile/update-secondary-cell'), params, apiHeader(token));
    return response;
  };

  const updatePassword = async (params) => {
    const response = await Post(BaseURL('profile/update-password'), params, apiHeader(token));
    return response;
  };

  const getProfile = async (params) => {
    const response = await Post(BaseURL('profile/get-profile'), params, apiHeader(token));
    return response;
  };

  const resetPassword = async (params) => {
    const response = await Post(BaseURL('auth/generate-otp-forgot'), params, apiHeader(token));
    return response;
  };

  const updateProfileImage = async (params) => {
    const response = await Post(BaseURL('profile/update-profile-image'), params, apiHeader(token));
    return response;
  };

  const getDoctorDashboard = async () => {
    const response = await Post(
      BaseURL('doctor/get-doctor-dashboard'),
      { doctorClinicId },
      apiHeader(token)
    );

    return response;
  };

  const sendReminderSms = async (params) => {
    const response = await Post(
      BaseURL('appointment/send-appointment-reminder-sms'),
      { doctorClinicId, ...params },
      apiHeader(token)
    );

    return response;
  };

  const registerAndAppointment = async (params) => {
    const response = await Post(
      BaseURL('appointment/register-and-add-appointment'),
      { doctorClinicId, ...params },
      apiHeader(token)
    );

    return response;
  };

  const editCheckedPatient = async (params) => {
    const response = await Post(
      BaseURL('clinic/edit-checked-patient'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );
    return response;
  };

  const getAppointmentList = async (params) => {
    const response = await Post(
      BaseURL('appointment/get-appointment-list'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );

    return response;
  };

  const editClinicFee = async (params) => {
    const response = await Post(
      BaseURL('profile/update-clinic-fees'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );

    return response;
  };
  const getDoctorFee = async (params) => {
    const response = await Post(
      BaseURL('profile/get-doctor-fee'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );

    return response;
  };
  const sendBulkAppointmentReminder = async (params) => {
    const response = await Post(
      BaseURL('appointment/send-bulk-appointment-reminder-sms'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );

    return response;
  };

  const deleteDoctorTime = async (params) => {
    const response = await Post(
      BaseURL('profile/delete-doctor-time'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );

    return response;
  };

  const updateDoctorTime = async (params) => {
    const response = await Post(
      BaseURL('profile/update-doctor-time'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );

    return response;
  };

  const updateAppointments = async (params) => {
    const response = await Post(
      BaseURL('profile/update-appointments'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );

    return response;
  };
  const updateSmsControl = async (params) => {
    const response = await Post(
      BaseURL('profile/update-sms-controls'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );

    return response;
  };

  const patientPayment = async (params) => {
    const response = await Post(
      BaseURL('clinic/add-payment'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );

    return response;
  };

  const getClinicStats = async (params) => {
    const response = await Post(
      BaseURL('doctor/get-clinic-dashboard'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );

    return response;
  };

  const getAllStats = async (params) => {
    const response = await Post(
      BaseURL('doctor/get-statistics'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );
    return response;
  };

  const getGraphView = async (params) => {
    const response = await Post(
      BaseURL('doctor/get-graph-view'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );
    return response;
  };
  const getPatientFlow = async (params) => {
    const response = await Post(
      BaseURL('doctor/get-patient-flow'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );
    return response;
  };
  const getAgeGroupChart = async (params) => {
    const response = await Post(
      BaseURL('doctor/get-age-group-chart'),
      { ...params, doctorClinicId },
      apiHeader(token)
    );
    return response;
  };

  return {
    registerPA,
    registerDoctor,
    generateOtpForSignup,
    getCities,
    verifyOtpForSignUp,
    forgotPassword,
    sigin,
    getAllPatientsListing,
    getPatientDetails,
    linkOrAddPatient,
    getAllClinicPatientsQueue,
    getAllClinicPatientsChecked,
    getAllPatients,
    getServices,
    addOrEditService,
    deleteService,
    deletePatientfromQueue,
    editPatientDetail,
    doctorSendNextPatient,
    getPatientQueueChecked,
    startSession,
    sessionEnd,
    getSession,
    editPatientQueuFees,
    requestNextPatient,
    addDrugAllergies,
    longtermConditions,
    addPreviousService,
    addDisability,
    addPreviousMedication,
    addSymptoms,
    addVitals,
    addDiagnosis,
    getAllMedicines,
    getTest,
    addTest,
    getOpdDetails,
    editRequestPatient,
    getPatientMedicalInformation,
    getAllAppointments,
    addAppointment,
    addDoctorTime,
    editAppointment,
    moveToQueue,
    getDoctorTimes,
    getAppointmentSlots,
    patientDuration,
    cancelAppointment,
    getAllSMSPackages,
    getPatientPaymentHistory,
    getSmsSubscription,
    addSmsSubscription,
    deleteSmsSubscription,
    getALLPackages,
    addSubscription,
    deleteSubscription,
    addMergeSubscription,
    generateOtpUpdateEmail,
    updateEmail,
    verifyOtpForUpdateEmail,
    updateSecondaryNumber,
    updatePassword,
    getProfile,
    resetPassword,
    updateProfileImage,
    getPackageSubscription,
    getDoctorDashboard,
    addDoctorNotes,
    addPrescription,
    sendReminderSms,
    registerAndAppointment,
    editCheckedPatient,
    getAppointmentList,
    editClinicFee,
    getDoctorFee,
    sendBulkAppointmentReminder,
    deleteDoctorTime,
    updateDoctorTime,
    updateSmsControl,
    updateAppointments,
    patientPayment,
    getClinicStats,
    getAllStats,
    getGraphView,
    getPatientFlow,
    getAgeGroupChart
  };
};

export default useApi;
